import styled from 'styled-components';

export const CallbackOptionContainer = styled.section`
  margin: 20px 0;
  padding: 0 12px;
`;

export const CallbackHeading = styled.h3`
  font-size: 18px;
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 10px 0 16px;
`;

export const CallbackDesc = styled.p`
  font-size: ${(props) => (props.popup ? '15px' : '14px')};
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 8px 0 14px;
`;

export const FloatLabelDiv = styled.div`
  position: relative;
  padding: ${(props) => (props.refundCallback ? '0 0 10px' : '20px 0 0')};
  align-items: center;
  grid-gap: 16px;
  position: relative;

  h2 {
    font-size: 16px;
    width: 90%;
    margin: 14px auto;
    color: rgba(0, 0, 0, 0.8);
  }
`;

export const CountryCode = styled.span`
  position: absolute;
  left: 6px;
  top: 31px;
  z-index: 9;
  font-size: 14px;
  font-weight: 500;
  color: #0000008c;
  padding-right: 6px;
  display: inline-block;
  border-right: 1px solid #00000052;
`;

export const MobileFloatLabel = styled.label`
  pointer-events: none;
  // position: absolute;
  top: ${(props) => (props.dynamic ? '50%' : '30px')};
  left: ${(props) => (props.isNumeric ? '46px' : '15px')};
  transition: all 0.1s linear;
  background-color: #fff;
  color: hsl(0deg, 0%, 0%, 40%);
  padding: 5px;
  box-sizing: border-box;
  display: none;
  font-size: 14px;

  @media (max-width: 720px) {
    display: block;
    padding: ${(props) => (props.refundCallback ? '0 20px' : '0 5px')};
  }
`;

export const FloatInput = styled.input`
  border: 1px solid hsl(0deg, 0%, 0%, 18%);
  border-radius: 6px;
  outline: none;
  width: 90%;
  max-width: ${(props) => (props.clinic ? '100%' : '460px')};
  padding: ${(props) => (props.isNumeric ? '0 16px 0 50px' : '0 16px')};
  height: 40px;
  font-size: 12px;
  font-family: 'Montserrat';
  color: hsl(0deg, 0%, 0%, 80%);
  transition: all 0.3s linear;
  box-sizing: border-box;
  font-weight: 500;
  margin: 10px auto;
  display: block;

  &.errorField {
    border: 2px solid #ef4e5e;
  }

  @media (max-width: 720px) {
    font-size: 16px;
    ::placeholder {
      color: #fff;
    }
  }

  &:focus {
    border: 1px solid hsl(0deg, 0%, 0%, 40%);

    @media (max-width: 720px) {
      ::placeholder {
        color: #fff;
      }
    }
  }

  &:focus
    + ${MobileFloatLabel},
    &:not(:placeholder-shown)
    + ${MobileFloatLabel} {
    font-size: 12px;
    top: 13px;
    color: hsl(0deg, 0%, 0%, 80%);
  }

  -moz-appearance: textfield; /* Firefox */

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none; /* Webkit browsers like Chrome and Safari */
    margin: 0; /* Remove the inner and outer spin buttons */
  }
`;

export const RequestCallbackCTA = styled.button`
  font-family: 'Montserrat';
  color: #fff;
  background: #ef4e5e;
  border: none;
  outline: none;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  margin: 30px 0;
  width: 100%;
  font-weight: 500;
  font-size: 16px;
  position: relative;
  overflow: hidden;

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
